import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-indicio-sinistro',
  templateUrl: './consulta-indicio-sinistro.component.html',
  styleUrls: ['./consulta-indicio-sinistro.component.scss']
})
export class ConsultaIndicioSinistroComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo = "";
  @Input() idConsulta = "";
  @Input() tipoConsulta = "";
  @Input() codigoControle = "";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  texto: any;



  listaFotos: any[] = [];

  @Input() token = '';

  constructor() { }

  ngOnInit() {
    this.setStatus();
  }

  ngOnChanges() {
    this.setStatus();
  }

  setStatus() {
    if (this.consulta && this.consulta.indicioSinistro == "NÃO") {
      this.statusMsg = "NADA CONSTA";
      this.status = 'success';
      this.texto = "Quando apontado como positivo, há a indicação provável que o veículo possa ter tido um acionamento em companhias de seguros por motivos diversos. Recomenda-se usar apenas como indicativo ou informação de apoio e reforça-se a necessidade de uma vistoria cautelar física com análise de estrutura para uma melhor tomada de decisão."
    }

    if (this.consulta && this.consulta.indicioSinistro == "SIM") {
      this.statusMsg = "CONSTA OCORRÊNCIA";
      this.status = 'danger';
      this.texto = "Quando apontado como positivo, há a indicação provável que o veículo possa ter tido um acionamento em companhias de seguros por motivos diversos. Recomenda-se usar apenas como indicativo ou informação de apoio e reforça-se a necessidade de uma vistoria cautelar física com análise de estrutura para uma melhor tomada de decisão."
    }
  }

}
